import React, { useContext, useEffect, useState } from "react";
import Container from "./PvinContainer";
import { FilterContext } from "../../context/Filter";

// Simple loader component
const Loader = () => (
  <div className="text-center py-4 text-gray-600 animate-pulse">
    Loading subscription details...
  </div>
);

const SubscriptionDetails = ({ data }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const { open } = useContext(FilterContext); // ✅ move inside function body


  useEffect(() => {
    // Mark data as loaded once it's defined
    if (data !== undefined) {
      setHasLoaded(true);
    }

    // If data is valid array, show loader briefly
    if (Array.isArray(data) && data.length > 0) {
      setShowLoader(true);
      const timeout = setTimeout(() => {
        setShowLoader(false);
      }, 800);

      return () => clearTimeout(timeout);
    }
  }, [data]);

  // 1. Initial load: show nothing (or full-screen loader if desired)
  if (!hasLoaded) return null;

  // 2. No data available after load
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <Container>
        <h2 className="text-xl font-semibold mb-2">Subscription Details</h2>
        <div className="text-sm text-red-600">
          No subscription data available.
        </div>
      </Container>
    );
  }

  // 3. Data exists but loader is active
  if (showLoader) {
    return (
      <Container>
        <h2 className="text-xl font-semibold mb-2">Subscription Details</h2>
        <Loader />
      </Container>
    );
  }

  // 4. Render the actual subscription data
  return (
    <Container>
      <h2 className="text-xl font-semibold">Subscription Details</h2>
      <table className={`table-auto w-full ${open ? 'text-xs' : 'text-sm'}  font-semibold border-collapse`}>
        <thead>
          <tr className="bg-[#056db3] text-white">
            <th className="px-4 py-2 border">Standard</th>
            <th className="px-4 py-2 border">Advance</th>
            <th className="px-4 py-2 border">Upgrade</th>
            <th className="px-4 py-2 border">Expired</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-2 border text-center">
              {data[4]?.["VehicleId Count"] ?? "0"}
            </td>
            <td className="px-4 py-2 border text-center">
              {data[0]?.["VehicleId Count"] ?? "0"}
            </td>
            <td className="px-4 py-2 border text-center">
              {data[3]?.["VehicleId Count"] ?? "0"}
            </td>
            <td className="px-4 py-2 border text-center">
              {data[9]?.["VehicleId Count"] ?? "0"}
            </td>
          </tr>
        </tbody>
      </table>
    </Container>
  );
};

export default SubscriptionDetails;
